export default "__VITE_ASSET__38d162ce__"